export default __webpack_public_path__ + "static/media/13.166db141.png";